import { Providers } from '@exp1/front-utils'
import {useIAmQuery} from 'hooks/useIAmQuery'

export const UserProvider = Providers.createUserProvider(window.location.hostname, useIAmQuery)
